// import Swiper JS
// import Swiper styles
//import 'swiper/swiper.min.css';
import Swiper, { Autoplay } from 'swiper';

// only run code when the section is on the page
if ($('.s-logo-slider').length !== 0) {
    Swiper.use([Autoplay]);
    /* global sLogoSlider__spaceBetweenSlides */
    /* global sLogoSlider__spaceBetweenSlidesMobile */

    // NOTE: make sure that your orginal/not copied slides take at least half of the slider width

    // list of available setting parameters https://swiperjs.com/swiper-api#parameters
    const swiperOptions = {
        slidesPerView: 'auto',
        loopedSlides: 20, // it might be requeried when using slidesPerView: 'auto'
        autoplay: {
            delay: 0, // delay after each come to view before moving to the next one
            disableOnInteraction: false,
        },

        loop: true,
        allowTouchMove: false,
        followFinger: false,
        simulateTouch: false,
        spaceBetween: sLogoSlider__spaceBetweenSlidesMobile,
        centeredSlides: true,
        speed: 6000,
        // Responsive breakpoints
        breakpoints: {
            1024: {
                spaceBetween: sLogoSlider__spaceBetweenSlides,
            },
        },
    };
    /* eslint-disable */
    const swiper = new Swiper('.s-logo-slider__container', swiperOptions);
    /* eslint-enable */

    /**
     * Load images when the section becomes visible
     * It fixes an issue with images that come into the viewport not appearing in Safari
     */
    // run this function imminently
    (function () {
        const options = {
            root: null, // use the document's viewport as the container
            rootMargin: '50px', // % or px - offsets added to each side of the intersection, it delays the intersection event by set distance
            threshold: 0, // percentage of the target element which is visible
        };

        // Callback docs: https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API#Targeting_an_element_to_be_observed
        const callback = (entries) => {
            entries.forEach((element) => {
                // If selector entry is visible in the viewport - according to the params set in `options`
                if (element.isIntersecting) {
                    const sliderImages = element.target.querySelectorAll('img');

                    sliderImages.forEach((slideImage) => {
                        const dataSrc = slideImage.dataset.src;

                        // replace the URL of the lazy load placeholder with the URL of the slide image
                        if (dataSrc) {
                            slideImage.src = dataSrc;
                        }
                    });

                    // stop observing sliders that were already visible to save memory
                    observer.unobserve(element.target);
                }
            });
        };

        // Create the intersection observer instance that is added to each element below
        const observer = new IntersectionObserver(callback, options);

        // get all swiper sliders
        const sliders = document.querySelectorAll('.s-logo-slider');

        // When document is ready, get all selectors from DOM and attach the observer to these
        sliders.forEach((slider) => {
            observer.observe(slider);
        });
    })();
}



// WEBPACK FOOTER //
// ./scripts/routes/sections/logo-slider.js